import { render, staticRenderFns } from "./ModifyClientYearReportDialog.vue?vue&type=template&id=5051edf8&scoped=true&"
import script from "./ModifyClientYearReportDialog.vue?vue&type=script&lang=js&"
export * from "./ModifyClientYearReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModifyClientYearReportDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=5051edf8&scoped=true&lang=css&"
import style2 from "./ModifyClientYearReportDialog.vue?vue&type=style&index=2&id=5051edf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051edf8",
  null
  
)

export default component.exports